import React from "react";
import FlowDetails from "./details/FlowDetails";
import TriggerPage from "./trigger/TriggerPage";
import { useParams } from "react-router-dom";
import ExecutionLogPage from "../../executionlog/ExecutionLogPage";
import FlowContentButtons from "./FlowContentButtons";
import ActionRenderer from "./action/ActionRenderer";
import SharedFlowVariablesPage from "./sharedFlowVariables/SharedFlowVariablesPage";
import FlowBackupPage from "../backups/FlowBackupPage";
import FlowStatusPage from "./status/FlowStatusPage";
const FlowContentPage = () => {
  const { section = "details" } = useParams();

  const renderContent = () => {
    switch (section) {
      case "trigger":
        return (
          <>
            <TriggerPage />
            <FlowContentButtons />
          </>
        );
      case "variables":
        return (
          <>
            <SharedFlowVariablesPage />
            <FlowContentButtons />
          </>
        );
      case "action":
        return (
          <>
            <ActionRenderer />
            <FlowContentButtons variant="action" />
          </>
        );
      case "status":
        return <FlowStatusPage />;
      case "log":
        return <ExecutionLogPage isGlobal={false} />;
      case "backups":
        return <FlowBackupPage />;
      case "details":
      default:
        return (
          <>
            <FlowDetails />
            <FlowContentButtons />
          </>
        );
    }
  };

  return (
    <div className="ihub-flex3 ihub-edit-content">
      {renderContent()}
    </div>
  );
};
export default FlowContentPage;
